import { LazyCategoryWell } from 'owa-categories';
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports  -- (https://aka.ms/OWALintWiki)
 * Baseline. Do not copy and paste"
 *	> '../index' import is restricted from being used. */
import { FolderTag } from '../index';
import { observer } from 'owa-mobx-react';
import {
    labelsContainerWithCategories,
    labelsContainerWithoutCategories,
} from 'owa-mail-listitem-styles/lib/scss/MailListItem.scss';

import { lazyStartSearchWithCategory } from 'owa-mail-search';
import type { MailboxInfo } from 'owa-client-types';
import React from 'react';

export interface MailListItemLabelsContainerProps {
    categories: string[];
    categoryContainerClass: string;
    categoryWellContainerClass: string;
    isSingleLine: boolean;
    mailboxGuids: string[];
    parentFolderDisplayName: string;
    parentFolderId: string;
    rowId: string;
    showCategories: boolean;
    showFolderTag: boolean;
    showPreviewText: boolean;
    mailboxInfo: MailboxInfo;
}

const defaultExport: React.FunctionComponent<MailListItemLabelsContainerProps> = observer(
    function MailListItemLabelsContainer(props: MailListItemLabelsContainerProps) {
        const {
            categories,
            categoryContainerClass,
            categoryWellContainerClass,
            isSingleLine,
            mailboxGuids,
            parentFolderDisplayName,
            parentFolderId,
            rowId,
            showCategories,
            showFolderTag,
            showPreviewText,
            mailboxInfo,
        } = props;

        return (
            <div
                className={
                    showCategories
                        ? labelsContainerWithCategories
                        : labelsContainerWithoutCategories
                }
            >
                {showCategories && (
                    <LazyCategoryWell
                        key={rowId}
                        categories={categories}
                        categoryContainerClass={categoryContainerClass}
                        categoryWellContainerClass={categoryWellContainerClass}
                        onCategoryClicked={onCategoryClicked}
                        mailboxInfo={mailboxInfo}
                    />
                )}
                {showFolderTag && (
                    <FolderTag
                        folderId={parentFolderId}
                        parentFolderDisplayName={parentFolderDisplayName}
                        isPreviewTextOn={showPreviewText}
                        isSingleLine={isSingleLine}
                        mailboxGuids={mailboxGuids}
                    />
                )}
            </div>
        );
    },
    'MailListItemLabelsContainer'
);
export default defaultExport;

const onCategoryClicked = async (
    ev: React.MouseEvent<unknown>,
    category: string,
    actionSource: string
) => {
    // Stop propagation so the click doesn't bubble up to container (i.e list view item and reading pane subject)
    ev.stopPropagation();

    const startSearchWithCategory = await lazyStartSearchWithCategory.import();
    startSearchWithCategory(actionSource, category);
};
